<template>
    <div class="">
        {{ config }}
        <br>
        {{ pdfUrl }}
        <iframe :src="pdfUrl" width="100%"></iframe>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pdfUrl: this.$route.query.wordURL, // 替换为你的 PDF 文件路径
        };
    }
};
</script>